import {
    ConnectedLink as ConnectedLinkNonTyped,
    Link as LinkNonTyped,
} from 'react-router5';
import { BaseLinkProps } from 'react-router5/dist/BaseLink';
import { PropsWithChildren } from 'react';
import * as React from 'react';
import { RouteParams, Routes } from '../../routes-table';

interface TypedLinkProps<K extends keyof RouteParams> extends BaseLinkProps {
    routeEnum: K;
    routeParams?: RouteParams[K];
}

const routePathToNameMap: { [path: string] : string} = {};
for (const routeName of Object.keys(Routes)) {
    const path = Routes[routeName] as string;
    routePathToNameMap[path] = routeName;
}

const Link = <K extends keyof RouteParams>(props: PropsWithChildren<Omit<TypedLinkProps<K>, 'router' | 'routeName'>>) => {
    const propsWithNameReplacingEnum = {
        ...props,
        routeName: routePathToNameMap[props.routeEnum],
    };

    delete propsWithNameReplacingEnum.routeEnum;

    return <LinkNonTyped { ...propsWithNameReplacingEnum } />;
};

const ConnectedLink = <K extends keyof RouteParams>(props: PropsWithChildren<Omit<TypedLinkProps<K>, 'routeName'>>) => {
    const propsWithNameReplacingEnum = {
        ...props,
        routeName: routePathToNameMap[props.routeEnum],
    };

    delete propsWithNameReplacingEnum.routeEnum;

    return <ConnectedLinkNonTyped { ...propsWithNameReplacingEnum } />;
};

export { Link, ConnectedLink };